import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import { Snackbar, Button } from "@mui/material"; // Using Material-UI for Snackbar
import Navbar from "./Navbar";
import Footer from "./Footer";
import Home from "./Home";
import Outsourcing from "./Outsourcing";
import Sales from "./Sales";
import Education from "./Education";
import Collaborations from "./Collaborations";
import ContactForm from "./ContactForm";
import Branding from "./MainServices/Branding";
import AppDevelopment from "./MainServices/AppDevelopment";
import Animations from "./MainServices/Animations";
import Marketing from "./MainServices/Marketing";
import PhotographyVideo from "./MainServices/PhotographyVideo";
import Print from "./MainServices/Print";
import WebDevelopment from "./MainServices/WebDevelopment";
import InvestPage from "./Investments/InvestPage";
import InvestMVP from "./Investments/InvestMVP";
import Business from "./PremiumServices/Business";
import EducationSupport from "./PremiumServices/EducationSupport";
import OrganizationalMissions from "./PremiumServices/OrganizationalMissions";
import PlatformDesinging from "./PremiumServices/PlatformDesinging";
import ProjectDevelopment from "./PremiumServices/ProjectDevelopment";
import TeamTraining from "./PremiumServices/TeamTraining";
import ChamberFormular from "./Sales/ChamberFormular";
import ChambersShigjeta from "./Sales/ChambersShigjeta";
import SalesAgentFormular from "./Sales/SalesAgentFormular";
import Consulting from "./ThirdPartyServices/Consulting";
import FinancialServices from "./ThirdPartyServices/FinancialServices";
import Mentoring from "./ThirdPartyServices/Mentoring";
import FormularContract from "./Contracting/FormularContract";
import PrivacyPolicy from "./Contracting/PrivacyPolicy";
import TermsCondition from "./Contracting/TermsCondition";
import BlogPage from "./Blog/Blog";
import BlogDetail from "./Blog/BlogDetail";
import BlogForm from "./Blog/BlogForm";
import Research from "./Blog/Research";
import Stories from "./Blog/Stories";
import CV from "./AboutUs/CV";
import Findouroffice from "./AboutUs/Findouroffice";
import Followus from "./AboutUs/Followus";
import Moreaboutus from "./AboutUs/Moreaboutus";
import Projects from "./AboutUs/Projects";
import ShigjetaShop from "./AboutUs/ShigjetaShop";
import ProductCard from "./AboutUs/ProductCard";
import ProductModal from "./AboutUs/ProductModal";
import ProductDetails from "./AboutUs/ProductDetails";
import BlogCard from "./Blog/BlogCard";
import BlogModal from "./Blog/BlogModal";
import InvestmentCard from "./Investments/InvestmentCard";
import InvestmentModal from "./Investments/InvestmentModal";
import InvestmentDetail from "./Investments/InvestmentDetails.js";
import Jobapplication from "./Contracting/Jobapplication";
import ShigjetaAcademyForm from "./Education/ShigjetaAcademyForm";
import InvestIDEA from "./Investments/InvestIDEA";
import BecomeAgent from "./Sales/BecomeAgent";
import ChatBot from "./ChatBot";
import ProjectDetails from "./AboutUs/ProjectDetails";
import "./App.css";

const App = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);

  useEffect(() => {
    // Check if terms are already accepted
    const accepted = localStorage.getItem("termsAccepted");
    if (!accepted) {
      setSnackbarOpen(true); // Show snackbar if terms are not accepted
    }

    // Mouse cursor customizations
    const cursorDot = document.querySelector("[data-cursor-dot]");
    const cursorOutline = document.querySelector("[data-cursor-outline]");

    if (!cursorDot || !cursorOutline) return;

    const handleMouseMove = (e) => {
      const posX = e.clientX;
      const posY = e.clientY;

      cursorDot.style.left = `${posX}px`;
      cursorDot.style.top = `${posY}px`;

      cursorOutline.animate(
        {
          left: `${posX}px`,
          top: `${posY}px`,
        },
        { duration: 500, fill: "forwards" }
      );
    };

    const handleHoverStart = () => {
      cursorDot.style.borderBottomColor = "#ffffff"; // Change to white
    };

    const handleHoverEnd = () => {
      cursorDot.style.borderBottomColor = "#49a760"; // Revert to green
    };

    // Add global mousemove listener
    window.addEventListener("mousemove", handleMouseMove);

    // Select elements to add hover effect
    const hoverElements = document.querySelectorAll(
      "button, .cta-button, a, .modal-close-btn, .contact-close-button, .contact-form-submit"
    );

    hoverElements.forEach((element) => {
      element.addEventListener("mouseenter", handleHoverStart);
      element.addEventListener("mouseleave", handleHoverEnd);
    });

    return () => {
      // Cleanup event listeners
      window.removeEventListener("mousemove", handleMouseMove);
      hoverElements.forEach((element) => {
        element.removeEventListener("mouseenter", handleHoverStart);
        element.removeEventListener("mouseleave", handleHoverEnd);
      });
    };
  }, []); // Run only once when the component mounts

  const handleAccept = () => {
    setTermsAccepted(true);
    localStorage.setItem("termsAccepted", "true"); // Save acceptance
    setSnackbarOpen(false);
  };

  const handleClose = () => {
    setSnackbarOpen(false);
  };

  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    fetch("/db/blog.json")
      .then((response) => response.text())
      .then((text) => setBlogs(JSON.parse(text)))
      .catch((error) => console.error("Error loading blogs:", error));
  }, []);

  return (
    <Router>
      <div className="cursor-dot" data-cursor-dot></div>
      <div className="cursor-outline" data-cursor-outline></div>
      <Navbar />
      <ContactForm />

      {/* Custom Alert HTML */}
      <div id="customAlert" style={{ display: "none" }}>
        <div id="alertBox">
          <span id="closeAlert">&times;</span>
          <h2>Content Protected</h2>
          <p>Please do not inspect or copy the content.</p>
          <button id="okButton">OK</button>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        message={
          <span>
            By continuing to explore our site, you’re agreeing to our{" "}
            <a href="/terms-condition" style={{ color: "#16a085" }}>
              Terms & Conditions
            </a>{" "}
            and{" "}
            <a href="/privacy-policy" style={{ color: "#16a085" }}>
              Privacy Policy
            </a>
            . Let’s create something great together!
          </span>
        }
        action={
          <Button
            style={{ color: "#16a085", cursor: "none" }}
            size="small"
            onClick={handleAccept}
          >
            Accept
          </Button>
        }
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      />

      <Routes>
        <Route path="/" element={<Navigate to="/home" />} />
        <Route path="/home" element={<Home />} />
        <Route path="/outsourcing" element={<Outsourcing />} />
        <Route path="/sales" element={<Sales />} />
        <Route path="/education" element={<Education />} />
        <Route path="/collaborations" element={<Collaborations />} />
        <Route path="/branding" element={<Branding />} />
        <Route path="/app-development" element={<AppDevelopment />} />
        <Route path="/animations" element={<Animations />} />
        <Route path="/marketing" element={<Marketing />} />
        <Route path="/photography-video" element={<PhotographyVideo />} />
        <Route path="/print" element={<Print />} />
        <Route path="/web-development" element={<WebDevelopment />} />
        <Route path="/investment" element={<InvestPage />} />
        <Route path="/invest-mvp" element={<InvestMVP />} />
        <Route path="/business" element={<Business />} />
        <Route path="/education-support" element={<EducationSupport />} />
        <Route
          path="/organizational-missions"
          element={<OrganizationalMissions />}
        />
        <Route path="/platform-designing" element={<PlatformDesinging />} />
        <Route path="/project-development" element={<ProjectDevelopment />} />
        <Route path="/team-training" element={<TeamTraining />} />
        <Route path="/chamber-formular" element={<ChamberFormular />} />
        <Route path="/chambers-shigjeta" element={<ChambersShigjeta />} />
        <Route path="/sales-agent-formular" element={<SalesAgentFormular />} />
        <Route path="/consulting" element={<Consulting />} />
        <Route path="/financial-services" element={<FinancialServices />} />
        <Route path="/mentoring" element={<Mentoring />} />
        <Route path="/formular-contract" element={<FormularContract />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-condition" element={<TermsCondition />} />
        <Route path="/blog" element={<BlogPage blogs={blogs} />} />
        <Route path="/blog/:blogId" element={<BlogDetail blogs={blogs} />} />
        <Route path="/blog-form" element={<BlogForm />} />
        <Route path="/research" element={<Research />} />
        <Route path="/stories" element={<Stories />} />
        <Route path="/cv" element={<CV />} />
        <Route path="/find-our-office" element={<Findouroffice />} />
        <Route path="/follow-us" element={<Followus />} />
        <Route path="/more-about-us" element={<Moreaboutus />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/shigjeta-shop" element={<ShigjetaShop />} />
        <Route path="/product-card" element={<ProductCard />} />
        <Route path="/product-modal" element={<ProductModal />} />
        <Route path="/shigjeta-shop/:productId" element={<ProductDetails />} />
        <Route path="/blog-card" element={<BlogCard />} />
        <Route path="/blog-modal" element={<BlogModal />} />
        <Route path="/investment-card" element={<InvestmentCard />} />
        <Route path="/investment-modal" element={<InvestmentModal />} />
        <Route
          path="/investment/:investmentId"
          element={<InvestmentDetail />}
        />
        <Route path="/jobapplication" element={<Jobapplication />} />
        <Route path="/ShigjetaAcademyForm" element={<ShigjetaAcademyForm />} />
        <Route path="/InvestIdea" element={<InvestIDEA />} />
        <Route path="/become-agent" element={<BecomeAgent />} />
        <Route path="/chat-bot" element={<ChatBot />} />
        <Route path="/projects/:projectId" element={<ProjectDetails />} />
        <Route path="*" element={<Navigate to="/home" />} />{" "}
        {/* Catch-all route */}
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
